import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

/**
 * Case para manejo de app
 */
export class AppComponent {
  /**
   * titulo con elq ue identificar el app
   */
  title = 'tae-front-web';
}
